import { render } from "./donateComp.vue?vue&type=template&id=77a783d0&scoped=true&ts=true"
import script from "./donateComp.vue?vue&type=script&lang=ts"
export * from "./donateComp.vue?vue&type=script&lang=ts"

import "./donateComp.vue?vue&type=style&index=0&id=77a783d0&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a783d0"]])

export default __exports__